var React = require('react');

function Component (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.9968 10.2503C17.1614 7.47391 21.3694 5.09899 26.0626 3.36986C26.9618 2.97948 27.8788 2.6212 28.806 2.30565C33.25 0.793207 37.9271 0.262557 41.9872 1.88659C44.4078 2.85484 47.1781 2.2839 49.6162 3.63844C51.4141 4.63727 53.19 5.73238 55.2109 6.18146C68.2696 9.08339 68.2886 24.3623 57.2453 29.5772C45.6169 35.0684 2.14598 52.7391 0.338237 30.1423C-0.398609 20.9317 6.12965 14.8284 12.9968 10.2503Z","fill":"currentColor"}));
}

Component.defaultProps = {"width":"66","height":"42","viewBox":"0 0 66 42","fill":"none"};

module.exports = Component;

Component.default = Component;
